import React from "react";
import { Card } from "../card";
import { TotalMembersOverview } from "../AdminDashboard/TotalMembersOverview";
import { StudentsGenderGraph } from "../AdminDashboard/StudentsDemoGraphy/StudentsGenderGraph";
import { StudentsGradeGraph } from "../AdminDashboard/StudentsDemoGraphy/StudentsGradeGraph";
import { useStudentsDemographyHook } from "../../hooks/studentsDemographyHooks/userStudentsDemographyHooks";
import { getValue } from "../../utils/object.utils";
import { useMobile } from "../../hooks/deviceHooks/useDevice.hooks";
const AdminDashboard = () => {
  const isMobile = useMobile();

  const { isLoading: isStudentDemographyLoading, data: studentsDemography } =
    useStudentsDemographyHook();

  const studentCountByGender = getValue(
    studentsDemography,
    "studentCountByGender",
    {}
  );

  const studentCountGraphData = getValue(
    studentsDemography,
    "studentCountGraphData",
    {}
  );

  console.log(studentCountGraphData, "STUDENT CUNT. DATA");

  return (
    <div>
      <div>
        <TotalMembersOverview />
      </div>

      {!isStudentDemographyLoading ? (
        <div
          className={`mt-10 grid ${
            isMobile ? "grid-rows-3" : "grid-cols-3"
          } gap-8`}
        >
          <div className="col-span-1 h-full">
            <Card wrapperStyle={{ height: "100%" }}>
              <div className="mt-10">
                <StudentsGenderGraph
                  studentCountByGender={studentCountByGender}
                />
              </div>
            </Card>
          </div>
          <div className={`${isMobile ? "col-span-1" : "col-span-2"} h-full`}>
            <Card wrapperStyle={{ height: "100%" }}>
              <div className="mt-10">
                <StudentsGradeGraph
                  studentCountGraphData={studentCountGraphData}
                />
              </div>
            </Card>
          </div>
        </div>
      ) : (
        <></>
      )}
    </div>
  );
};
export default AdminDashboard;
